import type { ModelsResponse } from './api';

export type ModelFamily = 'dg' | 'un' | 'hs' | 'emb';

export type ModelVersions = Record<ModelFamily, string[]>;

// What the UI offers when DGML cannot tell us what it serves: a build that predates
// GET /api/dgml/models only has dg-v4 and un-v1, but a newer build is more likely,
// so the list leans forward and a disabled version simply answers 503 when picked.
export const FALLBACK_VERSIONS: ModelVersions = {
  dg: ['v4', 'v5'],
  un: ['v1'],
  hs: ['v1'],
  emb: ['v3'],
};

const FAMILIES: ModelFamily[] = ['dg', 'un', 'hs', 'emb'];

function compareVersions(a: string, b: string): number {
  return parseInt(a.replace(/\D/g, ''), 10) - parseInt(b.replace(/\D/g, ''), 10);
}

// Turns DGML's flat enabled list (dg-v4, dg-v5, hs-v1, ...) into one ascending
// version list per family. A family DGML serves nothing for comes back empty.
export function groupEnabledVersions(models: ModelsResponse): ModelVersions {
  const grouped: ModelVersions = { dg: [], un: [], hs: [], emb: [] };

  for (const key of models.enabled) {
    const [family, version] = key.split('-', 2);
    if (FAMILIES.includes(family as ModelFamily) && version) {
      grouped[family as ModelFamily].push(version);
    }
  }

  for (const family of FAMILIES) {
    grouped[family].sort(compareVersions);
  }

  return grouped;
}

export function latestVersion(versions: string[]): string | undefined {
  return versions[versions.length - 1];
}
